// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__A8GC7","checkbox--red":"Checkbox_checkbox--red__7vOZi","checkbox--green":"Checkbox_checkbox--green__+EIef"};